'use strict';

var FeatureFlagService = /*@ngInject*/ function($http, REST_URL) {
  var _flags = {};
  var _ready = false;
  var _initPromise = null;

  this.init = function() {
    _initPromise = $http.get(REST_URL.base + '/feature-flags')
      .then(function(response) {
        (response.data || []).forEach(function(flag) {
          _flags[flag.id] = flag.enabled;
        });
      })
      .catch(function() {
        // Fail open -- defaults remain (redirects ON)
      })
      .finally(function() {
        _ready = true;
      });
    return _initPromise;
  };

  this.isReady = function() {
    return _ready;
  };

  this.whenReady = function() {
    return _initPromise;
  };

  this.isEnabled = function(flagId) {
    return _flags.hasOwnProperty(flagId) ? _flags[flagId] : true;
  };
};

module.exports = FeatureFlagService;
